import React from 'react';
import { Alert, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { dismissWarning } from '../slicers/BrowserSlice';

const BrowserWarningBanner = () => {
    const dispatch = useDispatch();
    const { showWarning, warningMessage, browserInfo } = useSelector((state) => state.browser);

    if (!showWarning || !warningMessage) {
        return null;
    }

    const handleDismiss = () => {
        dispatch(dismissWarning());
    };

    const getSeverityVariant = (severity) => {
        switch (severity) {
            case 'error':
                return {
                    'backgroundColor': '#EBB6B666', 
                    'border': '#946705',
                    'color': '#000000'
                };
            case 'warning':
                return {
                    'backgroundColor': '#FDF3CF', 
                    'border': '#946705',
                    'color': '#000000'
                };

            default:
                // info
                return {
                    'backgroundColor': '#B2C7CE66', 
                    'border': '#B2C7CE',
                    'color': '#000000'
                };
        }
    };

    const severityStyles = getSeverityVariant(warningMessage.severity);

    return (
        <Alert 
            className="mb-0"
            style={{
                borderRadius: 10,
                padding: '12px 20px',
                fontSize: '14px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                backgroundColor: severityStyles.backgroundColor,
                border: `1px solid ${severityStyles.border}`,
                color: severityStyles.color,
                margin: '10px'
            }}
        >
           <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                <div style={{display: 'flex', alignItems: 'flex-start', flexDirection: 'column'}}>
                    <strong className="subtitle-2">{warningMessage.title}</strong>
                    <span className="body-2" >{warningMessage.message}</span>
                </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                {browserInfo && browserInfo.isSupported && (
                    <Button 
                        variant="outline-light" 
                        size="sm"
                        onClick={() => window.location.reload()}
                        style={{ fontSize: '12px', color: 'inherit', borderColor: 'currentColor'}}
                    >
                        Refresh
                    </Button>
                )}
                <Button 
                    variant="outline-light" 
                    size="sm"
                    onClick={handleDismiss}
                    style={{ fontSize: '12px', color: 'inherit', borderColor: 'currentColor'}}

                >
                    Dismiss
                </Button>
            </div>
        </Alert>
    );
};

export default BrowserWarningBanner;
